/*
 * Module for loading and displaying the software Notices text.
*/

rs.module("content/application/notices",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, noticesUrl) {

            var licenseContainer = $.js(jsSelectors.licenseContainer);
            $.get(noticesUrl).done(function(data){
                $.js(jsSelectors.loading).hide();
                licenseContainer.text(data);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);